'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ../~/react-slick/lib/index.js
// module id = 140
// module chunks = 3